import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'ui-confirmation-dialog',
  imports: [MatButton, MatDialogModule],
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationDialogComponent {
  protected readonly data = inject<ConfirmationData>(MAT_DIALOG_DATA);
}

type ConfirmationData = {
  title?: string;
  body: string;
  confirmText?: string;
  declineText?: string;
};
